module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter has-text-left",
    attrs: {
      "id": "app"
    }
  }, [_c('form', {
    on: {
      "submit": _vm.handleLogin
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Username"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password",
      "password-reveal": ""
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-fullwidth",
    on: {
      "click": function($event) {
        return _vm.login(_vm.credentials)
      }
    }
  }, [_vm._v("LOGIN")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f87b417"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 977
// module chunks = 0